<template>
	<div>
	<div class="row">
			<form>
				<div class="col-xs-12 col-sm-6 col-lg-3">
					<div class="form-group">
						<label for="owner">Coach</label>
						<select id="owner" name="owner" v-model="owner_id" class="form-control" @change="this.loadWorkouts">
							<option v-for="owner in owners" :value="owner.id">
								{{ owner.first_name }} {{ owner.last_name }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-lg-3">
					<div class="form-group">
						<label for="course">Course</label>
						<select id="course" v-model="course" class="form-control" @change="this.loadWorkouts">
							<option value="SCM">SCM</option>
							<option value="LCM">LCM</option>
						</select>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-lg-3">
					<div class="form-group">
						<label for="min_distance">Distance</label>
						<div class="input-group">
						<input  id="min_distance" class="form-control" v-model="min_distance" type="number" @input="loadWorkouts" />
							<span class="input-group-addon">-</span>
						<input class="form-control" v-model="max_distance" type="number" @input="loadWorkouts"/>
						</div>
					</div>
				</div>
			</form>
	</div>
<div class="row">
	<div class="col-xs-12">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">{{ tableTitle }}</h3>
				</div>
				<table class="table table-bordered table-striped">
					<thead>
					<tr>
						<th class="row-actions row-actions-2-btn">&nbsp;</th>
						<th>Coach</th>
						<th>Workout Name</th>
						<th class="text-right">Distance</th>
						<th class="text-right">Duration</th>
						<th class="text-center">Course</th>
						<th class="text-center">Created</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(workout,index) in workouts" v-if="workouts.length > 0">
						<td class="row-actions row-actions-2-btn">
							<button class="btn btn-danger btn-sm" @click="handleDelete(index, workout)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
							<!-- <button class="btn btn-primary btn-sm" @click="handleEdit(index, group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> -->
							<button class="btn btn-primary btn-sm" @click="handleEdit(index, workout)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
						</td>
						<td>
							{{ workout.owner != null ? workout.owner.name : '' }}
						</td>
						<td>
							<span class="not-favourite glyphicon glyphicon-star-empty" aria-hidden="true" v-show="!workout.favourite"></span>
							<span class="favourite glyphicon glyphicon-star" aria-hidden="true" v-show="workout.favourite"></span>
							{{ workout.workout_name }}
						</td>
						<td class="text-right">
							{{ workout.distance }}m
						</td>
						<td class="text-right">
							{{ formatSecondsAsTime(workout.duration) }}
						</td>
						<td class="text-center">
							{{ workout.course }}
						</td>
						<td class="text-center">
							{{ new Date(workout.created_at).toLocaleDateString() }}
						</td>
					</tr>
					<tr v-if="workouts.length == 0">
						<td colspan="9" align="center">
							<strong v-if="!this.isLoading">There are no workouts to display</strong>
							<strong v-if="this.isLoading">Loading workouts...</strong>
						</td>
					</tr>
					</tbody>
				</table>
	
			</div>


		</div>
	</div>
	</div>

</template>

<style scoped>
.favourite {
	color: #fdee00;
}
.not-favourite {
	color: #fdee00;
}
</style>

<script>

import { Loading } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);
import { formatSecondsAsTime } from "../helpers/timeHelper";

export default {
	props: {
		title: {
			type: String,
			default: "Workouts"
		},
		can_manage: {
			type: Boolean,
			default: false
		},
		filterOwnerId: {
			type: Number,
			default: null
		},
		owners: {
			type: Object,
			default: null
		}
	},
	data: function () {
		return {
			workouts: [],
			tableTitle: this.title,
			canManage: this.can_manage,
			editingIndex: -1,
			editingWorkout: {},
			isLoading: false,
			owner_id: this.filterOwnerId,
			course: 'SCM',
			min_distance: 0,
			max_distance: 9999,
		}
	},
	beforeCreate() {
		this.formatSecondsAsTime = formatSecondsAsTime;
	},
	mounted() {
		this.debug('Workout component mounted.');
		this.loadWorkouts();
	},
	methods: {

		handleDelete(index, record) {
			this.debug('Deleting record: ' + record.id);
			axios.delete(`/api/v1/workout/${record.id}`).then((response) => {
				// this.loadingInstance.close();
				this.debug(response.data);
				this.loadWorkouts();
				this.$message({message: 'The workout has been deleted.', type: 'success'});
			}).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem deleting the workout.', type: 'error'});
			});
		},
		handleEdit(index, record) {
			this.debug('Editing record: ' + record.id);
			this.debug('Index: ' + index)
			this.debug(record);
			this.$emit('edit-workout', record.id, record);
		},
		loadWorkouts() {
			this.debug('loadWorkouts()');
			this.isLoading = true;
			
			axios.get(`/api/v1/workouts?filters=owner_id:${this.owner_id},course:${this.course},distance:${this.min_distance}-${this.max_distance}`)
				.then(response => {
					this.workouts = response.data;
				})
				.catch(error => {
					this.$message({message: 'There was a problem fetching workouts.', type: 'error'});
					console.log(error);
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		debug(message) {
			console.log('WorkoutList: ' + message);
		}
	}
}
</script>
